import React, {useEffect, useState} from 'react';
import {observer} from "mobx-react";

import {SoonPage} from "./soon/Soon";
import {Login} from "../components/Login/Login";
import {Logout} from "../components/Login/Logout";
import {Footer} from "../components/footer/Footer";
import {Service_Edit} from "../components/service_edit/Service_Edit";

import {IUserInfo} from "../models/user";
import {Link} from "react-router-dom";
import footer_my_calendar from "../images/ui/footer_my_calendar.png";
import footer_my_service from "../images/ui/footer_my_service.png";
import footer_my_profile from "../images/ui/footer_my_profile.png";
import footer_my_clients from "../images/ui/footer_my_clients.png";
import {AlertColor, TextField} from "@mui/material";
import {Service_List} from "../components/service_list/Service_List";
import AddHomeIcon from "@mui/icons-material/AddHome";
import Button from "@mui/material/Button";


import Grid from "@mui/material/Unstable_Grid2";
import {FooterLinks_MainMenu} from "../components/footer/FooterLinks_MainMenu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {User_Profile_AvaName} from "../components/User_Profile/User_Profile_AvaName";
import {User_Profile_EmploymentInvites} from "../components/User_Profile/User_Profile_EmploymentInvites";
import {User_Profile_Employments} from "../components/User_Profile/User_Profile_Employments";

interface Props{
    userAuth: boolean;
    setUserAuth:  React.Dispatch<React.SetStateAction<boolean>>;
    userInfo: IUserInfo;
    setUserInfo:  React.Dispatch<React.SetStateAction<IUserInfo>>;
    footer: React.ReactNode;
    setFooter: React.Dispatch<React.SetStateAction<React.ReactNode>>;
    setGlobalMessage:  React.Dispatch<React.SetStateAction<{type: AlertColor, message: String}>>;
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
    //authFrame: Window | null;
    //handleAdd: (e : React.FormEvent) => void;
}
export const UserProfilePage = ({userAuth, setUserAuth, userInfo, setUserInfo, footer, setFooter, setGlobalMessage, setIsLoading} : Props) => {



    useEffect( () => {
        setFooter(FooterLinks_MainMenu(["home", "bookings", "services", "clients"]))
    }, [])
    /*
    useEffect(() => {
        const hostname = window.location.hostname;
        const subdomain = hostname.split('.')[0];
        console.log('Subdomain: ' + subdomain);

    }, []);
     */




    return (
        <div>
            {/*<SoonPage/>*/}




            { userAuth ?
                <>
                    Ваші дані

                    <User_Profile_AvaName
                        userAuth={userAuth}
                        setUserAuth={setUserAuth}
                        userInfo={userInfo}
                        setUserInfo={setUserInfo}
                        footer={footer}
                        setFooter={setFooter}
                        setGlobalMessage={setGlobalMessage}
                        setIsLoading={setIsLoading}
                    />

                    <User_Profile_EmploymentInvites
                        userAuth={userAuth}
                        setUserAuth={setUserAuth}
                        userInfo={userInfo}
                        setUserInfo={setUserInfo}
                        footer={footer}
                        setFooter={setFooter}
                        setGlobalMessage={setGlobalMessage}
                        setIsLoading={setIsLoading}
                    />

                    {/*<p> - Показати де я на роботі </p>*/}
                    <User_Profile_Employments
                        userAuth={userAuth}
                        setUserAuth={setUserAuth}
                        userInfo={userInfo}
                        setUserInfo={setUserInfo}
                        footer={footer}
                        setFooter={setFooter}
                        setGlobalMessage={setGlobalMessage}
                        setIsLoading={setIsLoading}
                    />




                    <p> - Показати рейтинг та статистику? </p>
                    <p> - Історія : запрошень на роботу, записів </p>



                    <div style={{paddingTop:'400px'}}></div>
                    <Logout
                        userAuth={userAuth}
                        setUserAuth={setUserAuth}
                        userInfo={userInfo}
                        setUserInfo={setUserInfo}
                    />
                </>

                :
                <Login
                    userAuth={userAuth}
                    setUserAuth={setUserAuth}
                    userInfo={userInfo}
                    setUserInfo={setUserInfo}
                    setGlobalMessage={setGlobalMessage}

                />
            }
        </div>
    );
};
